"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/web.timers.js");

var _lodash = _interopRequireDefault(require("lodash"));

var _util = require("sk-ui/lib/utils/util");

var _vue = _interopRequireDefault(require("vue"));

var _dialog = _interopRequireDefault(require("./dialog.js"));

/**
 * Created by wqw on 2018/2/6.
 */
var DEFAULT_OPTION = {// width: '550px'
};

function newInstanceDialog(properties) {
  var _props = properties || {};

  var template = _props.template || '';
  var props = {};
  var removeCurDialog = properties.removeCurDialog;
  delete _props.removeCurDialog;

  if (_props.props.showCustomFooter || _props.props.showFooter === false) {
    _props.props.showDefaultFooter = false;
  }

  if (_props.props.showFooter === false) {
    _props.props.showDefaultFooter = false;
  }

  _props.props = Object.assign({}, DEFAULT_OPTION, _props.props);
  Object.keys(_props.props).forEach(function (prop) {
    if (!_lodash["default"].isObject(_props[prop])) {
      props[(0, _util.camelcaseToHyphen)(prop)] = _props.props[prop];
    }
  });
  var data = Object.assign({
    dialogVisible: false,
    showFooter: true,
    loading: false,
    closeOnHashChange: true
  }, _props.props);
  var dialog = new _vue["default"]({
    name: 'ExDialog',
    componentName: 'ExDialog',
    data: data,
    parent: _props.app || newInstanceDialog.appContext || this,
    components: (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, _props.components), {}, (0, _defineProperty2["default"])({}, _dialog["default"].name, _dialog["default"])),
    render: function render(h) {
      var _vm = this;

      var dioData = {
        props: Object.assign(data, {
          visible: this.dialogVisible
        }),
        on: {
          close: this.cancel,
          cancel: this.cancel,
          ok: this.ok
        }
      };
      var dialogVNode = h("el-dialog", (0, _babelHelperVueJsxMergeProps["default"])([{}, dioData]));
      dialogVNode.componentOptions = dialogVNode.componentOptions || {};
      dialogVNode.componentOptions.children = dialogVNode.componentOptions.children || [];

      if (_lodash["default"].isFunction(template)) {
        template = template(h);
      }

      dialogVNode.componentOptions.children.push(template);
      Object.assign(dialogVNode.componentOptions.propsData, props);
      return dialogVNode;
    },
    mounted: function mounted() {
      if (this.closeOnHashChange) {
        window.addEventListener('hashchange', this.cancel);
      }
    },
    methods: {
      cancel: function cancel() {
        if (!this.dialogVisible) {
          return;
        }

        this.dialogVisible = false;
        var componentInstance = this.$children[0].$slots["default"][0].componentInstance;
        var onCancel = componentInstance && componentInstance.handleCancel;
        onCancel && onCancel();
        this.remove();
      },
      ok: function ok() {
        var _this = this;

        var componentInstance = this.$children[0].$slots["default"][0].componentInstance;
        var okFun = componentInstance.handleOk;
        this.loading = true;

        if (_lodash["default"].isFunction(okFun)) {
          var promise = okFun.call(componentInstance);

          if (_lodash["default"].isUndefined(promise) || _lodash["default"].isBoolean(promise) && promise) {
            this.dialogVisible = false;
            this.remove();
          } else if (_lodash["default"].isObject(promise) && promise.then) {
            promise.then(function () {
              // Promise成功不去掉loading, 直接关闭窗口，防止多次点击
              // this.loading = false;
              _this.dialogVisible = false;

              _this.remove(); // 执行回调函数


              template.data.attrs && Object.keys(template.data.attrs).forEach(function (prop) {
                if (_lodash["default"].isFunction(template.data.attrs[prop])) {
                  template.data.attrs[prop]();
                }
              });
            }, function () {
              _this.loading = false;
            });
            this.dialogVisible = true;
            return promise;
          } else if (!promise) {
            this.dialogVisible = true;
            this.loading = false;
          }
        } else {
          this.loading = false;
          this.dialogVisible = false;
          this.remove();
        }
      },
      remove: function remove() {
        var _this2 = this;

        removeCurDialog && removeCurDialog(this.$children[0].title);
        removeCurDialog = null;
        setTimeout(function () {
          _this2.destroy();
        }, 500);
      },
      destroy: function destroy() {
        this.$destroy();

        try {
          document.body.removeChild(this.$el);
        } catch (e) {// console.log(e)
        }
      }
    },
    beforeDestroy: function beforeDestroy() {
      if (this.closeOnHashChange) {
        window.removeEventListener('hashchange', this.cancel);
      }
    }
  }).$mount();
  var modal = dialog.$children[0];
  document.body.appendChild(dialog.$el);
  return {
    show: function show(props) {
      dialog.dialogVisible = true;
    },
    remove: function remove() {
      dialog.dialogVisible = false;
      dialog.remove();
    },
    component: modal
  };
}

var _default = newInstanceDialog;
exports["default"] = _default;